export default __webpack_public_path__ + "static/media/braces.0dbe2231.svg";